var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueberry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_63417)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3580_63417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3580_63417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731.64 67.1267C1846.05 177.101 1919.16 329.697 1925.5 499.361V-181.002H1890.92C1857.82 -85.9304 1802.69 -1.16838 1731.64 67.1267Z",
    fill: "url(#paint0_linear_3580_63417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.498 67.1267C783.435 -1.18845 728.317 -85.9304 695.223 -181.002H307.596C362.011 -87.5551 393.22 21.0952 393.22 137.046C393.22 401.762 230.696 628.47 0.0175781 722.96V903.114H786.604C707.197 797.352 660.143 665.917 660.143 523.47C660.143 344.178 734.716 182.316 854.498 67.1467V67.1267Z",
    fill: "url(#paint1_linear_3580_63417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.498 67.1267C968.263 -42.2457 1122.8 -109.478 1293.07 -109.478C1463.34 -109.478 1617.88 -42.2256 1731.64 67.1267C1802.71 -1.18845 1857.82 -85.9304 1890.92 -181.002H695.203C728.298 -85.9304 783.435 -1.16838 854.478 67.1267H854.498Z",
    fill: "url(#paint2_linear_3580_63417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.201 137.046C393.201 21.0952 361.992 -87.535 307.576 -181.002H-0.00195312V722.94C230.677 628.45 393.201 401.742 393.201 137.026V137.046Z",
    fill: "url(#paint3_linear_3580_63417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.498 67.1268C968.263 176.499 1122.8 243.731 1293.07 243.731C1463.34 243.731 1617.88 176.479 1731.64 67.1268C1617.88 -42.2455 1463.34 -109.478 1293.07 -109.478C1122.8 -109.478 968.263 -42.2255 854.498 67.1268Z",
    fill: "url(#paint4_linear_3580_63417)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_63417",
    x1: 1925.04,
    y1: -479.402,
    x2: 1925.04,
    y2: 637.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_63417",
    x1: -1397.56,
    y1: 163.619,
    x2: 1222.74,
    y2: 163.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_63417",
    x1: 1033.86,
    y1: 1871.64,
    x2: 2215.41,
    y2: -752.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_63417",
    x1: 1668.84,
    y1: -246.307,
    x2: -316.487,
    y2: 814.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_63417",
    x1: 1467.89,
    y1: -591.93,
    x2: 1074.04,
    y2: 332.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_63417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueberry);
export default __webpack_public_path__ + "static/media/blueberry.6fde9f1408582d2a030d7f1f37f1345e.svg";
export { ForwardRef as ReactComponent };